import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="lm-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#8B5CF6" />
        <stop offset="1" stopColor="#FF6B00" />
      </linearGradient>
    </defs>
    <path d="M14 24V14h10M40 14h10v10M50 40v10H40M24 50H14V40" fill="none" stroke="url(#lm-g)" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="32" cy="32" r="8" fill="#FF6B00" className="rec-dot" />
  </svg>
);

export const Logo = ({ to = "/" }) => (
  <Link to={to} data-testid="brand-logo-link" className="group flex items-center gap-2.5">
    <LogoMark className="h-8 w-8 transition-transform duration-500 group-hover:rotate-90" />
    <span className="font-display text-xl font-extrabold tracking-tight">
      eutevi<span className="text-flash">lá</span>
    </span>
  </Link>
);
